import type TasProgramInstanceModel from 'tio-common/models/tas-program-instance';

/**
 * Builds a filter object for querying tas-unified-institution with program template and institution IDs.
 *
 * @param programInstance - The tas-program-instance to extract IDs from
 * @returns A filter object for use with store.query()
 *
 * @remarks
 * The 'tas-program-template' key with hyphens is valid at runtime. The TypeScript error occurs
 * when passing this filter to store.query() due to Ember Data's strict type definitions.
 */
export function buildSchoolFilter(programInstance: TasProgramInstanceModel) {
  const filter: Record<string, string | number | undefined> = {
    'tas-program-template': programInstance.tasProgramTemplate.id ?? undefined,
  };

  const dapipInstitutionId = programInstance.fields['DAPIP_INSTITUTION_ID']?.values?.[0];
  const tasInstitutionId = programInstance.fields['TAS_INSTITUTION_ID']?.values?.[0];

  if (dapipInstitutionId) {
    filter['dapip-id'] = dapipInstitutionId;
  }

  if (tasInstitutionId) {
    filter['institution-id'] = tasInstitutionId;
  }

  return filter;
}
